module.exports = __webpack_public_path__ + "img/tick-blue.eb15ad13.svg";